import React, { PropsWithChildren } from 'react';
import theme from './BuyerDocumentCardMobile.module.scss';
import { Trans } from '@lingui/react/macro';
import { SimpleCard } from '@/components/Cards';
import { DateDisplay } from '@/components/localization';
import { Button } from '@ygtechnologies/rubus-ui';
import { faDownload, faHistory } from '@fortawesome/pro-light-svg-icons';
import { BuyerDocumentCardInternalProps } from '../BuyerDocumentCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TranslatableText } from '@/types';
import { BuyerDocumentIcon } from '../../BuyerDocumentIcon';

interface SectionProps extends PropsWithChildren {
    caption: TranslatableText;
}
const Section: React.FC<SectionProps> = ({ caption, children }) => {
    return (
        <div>
            <span className={theme.label}>{caption}</span>
            <span className={theme.content}>{children}</span>
        </div>
    );
};

const BuyerDocumentCardMobile: React.FC<BuyerDocumentCardInternalProps> = ({
    subTitle: name,
    icon,
    title: typeName,
    lastModified,
    versionNumber,
    downloadLink,
    openLink,
    fileMetadata,
    onLinkClick,
    onHistoryClick,
}) => {
    return (
        <SimpleCard className={theme.card}>
            <div className={theme.infoSection}>
                <BuyerDocumentIcon fileMetadata={fileMetadata} />

                <div className={theme.details}>
                    <div>
                        {icon && <FontAwesomeIcon className={theme.typeIcon} icon={icon} />}

                        <a
                            onClick={onLinkClick}
                            className={theme.openDocumentLink}
                            href={openLink}
                            target="_blank"
                            rel="noopener noreferrer">
                            {typeName}
                        </a>
                    </div>

                    <Section caption={<Trans>Name</Trans>}>{name}</Section>

                    {lastModified && (
                        <Section caption={<Trans>Modified</Trans>}>
                            <DateDisplay value={lastModified} />
                        </Section>
                    )}

                    {versionNumber && <Section caption={<Trans>Version</Trans>}>{versionNumber}</Section>}
                </div>
            </div>

            <div className={theme.buttons}>
                <Button as="a" icon={faDownload} variant="tertiary" href={downloadLink} target="_blank">
                    <Trans>Download</Trans>
                </Button>

                {onHistoryClick && (
                    <Button onClick={onHistoryClick} icon={faHistory} variant="tertiary">
                        <Trans>Show history</Trans>
                    </Button>
                )}
            </div>
        </SimpleCard>
    );
};

export default BuyerDocumentCardMobile;
